var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMdMicrosoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#34b5cb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    className: "cls-1",
    d: "M23.52,8.17q10.47-1.59,21-3V23.52c-7,0-14,.13-21,.15V8.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    className: "cls-1",
    d: "M5.79,10.65c5.26-.81,10.54-1.51,15.82-2.17q0,7.62,0,15.25c-5.28,0-10.55.07-15.83.06V10.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path29",
    className: "cls-1",
    d: "M5.79,25.39c5.27,0,10.54.07,15.81.06,0,5.09,0,10.19,0,15.29C16.34,40,11.07,39.28,5.79,38.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path31",
    className: "cls-1",
    d: "M23.49,25.59h21V43.94c-7-1-14-2-21-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMdMicrosoft);
export default __webpack_public_path__ + "static/media/Icon-MD-Microsoft.c59279697eb3226037adc7dc29dde96a.svg";
export { ForwardRef as ReactComponent };